import React from "react";

export function DashbboardHelp2() {
    return (
        <div style={{
            fontFamily: 'PPMoriRegular',
            textAlign: 'justify',
            marginRight: 40,
            fontSize: '1.2em'
        }}>
            <p>Environmental concern, mirroring global challenges but with unique local characteristics. The region's
                reliance on conventional vehicles powered by gasoline and diesel, the increasing vehicle ownership due
                to economic growth, and the sprawling urban development contribute to rising greenhouse gas emissions.
                Factors like fuel type, vehicle efficiency, traffic volume, and travel distances, are all instrumental
                in shaping the region emissions profile. Efforts to reduce these emissions focus on enhancing fuel
                efficiency, transitioning to electric and alternative fuel vehicles, improving public transportation
                systems, and promoting sustainable mobility practices like cycling and walking. Accordingly, the
                transport emissions component of the Carbon Footprint Simulator considers the following parameters:
                <ul>
                    <li><b>Number of kilometers traveled by type of trip, divided in inbound trips, outbound trips and
                        in boundary trips.</b> To map out where and how active population (ages 5-64) moves
                        for work or school, the tool focuses on the active portion of the population and categorizes
                        trips as inbound (coming into an area from another province), outbound (leaving an area for a
                        different province), or in-boundary (moving within the same province). For movements within a
                        province, it adds up potential travelers, including students and workers, and then figures out
                        travel patterns based on where jobs are located, using workplace data from <a
                            href="https://www.openstreetmap.org/#map=6/42.088/12.564" target="_blank">OpenStreetMap</a>.
                    </li>
                    <li><b>Distribution among different modes of transport</b> (automobile, motorcycle, bicycle, foot)
                        is determined using data sourced from <a href="https://insights.sustainability.google/"
                                                                 target="_blank">Google's Environmental Insight
                            Explorer</a> , which are derived from the regionally-specific estimates provided by the <a
                            href="https://www.c40knowledgehub.org/s/article/Climate-action-for-URBan-sustainability-CURB-scenario-planning-tool"
                            target="_blank">Climate Action for Urban Sustainability (CURB) tool</a>. The modal split
                        values considered for each province, are calculated as averages based on a representative sample
                        of &gt;1200 cities.
                    </li>
                    <li><b>Fuel efficiency by transport mode</b> (automobile, motorcycle) obtained from the <a
                        href="https://www.c40knowledgehub.org/s/article/Climate-action-for-URBan-sustainability-CURB-scenario-planning-tool"
                        target="_blank">CURB tool</a>.
                    </li>
                    <li><b>CO2 Emission factor by transport mode</b> is also derived from the <a
                        href="https://www.c40knowledgehub.org/s/article/Climate-action-for-URBan-sustainability-CURB-scenario-planning-tool"
                        target="_blank">CURB tool</a>.
                    </li>
                </ul>
                Upon choosing a specific province, users can increase or decrease the overall number of kilometers
                traveled for inbound, outbound and within-boundary trips, adjust the proportions between different transport
                modes, and modify the operational fuel efficiency of considered motorized vehicles. These adjustments
                enable the visualization of the corresponding rise or fall in CO2 emissions within the transportation
                sector.
            </p>
        </div>
    )
}